import React, { useState } from 'react'
import { connect } from 'react-redux'
import store from 'store'
import { Upload, notification, Modal } from 'antd'
import { InboxOutlined } from '@ant-design/icons'
import _ from 'lodash'

// mapStateToProps redux-saga
const mapStateToProps = ({ files }) => ({ files })

// Upload dragger
// const { Dragger } = Upload

const UploadModal = ({ dispatch, open, setOpen }) => {
  // const [okButtonDisable, setOkButtonDisable] = useState(true)
  const [uploadList, setuploadList] = useState([])
  const MAX_FILE_UPLOAD = 10

  /**
   * This dispatch action call is only for the state
   * The request is made in the upload component
   */
  const uploadImages = uploadData => {
    const { file, fileList } = uploadData
    setuploadList([])
    // set the file list to keep only the three last upload

    if (_.size(fileList) > MAX_FILE_UPLOAD) {
      notification.warn({
        message: `Max ${MAX_FILE_UPLOAD} files upload`,
        description: `${file.name} ignored`,
      })
    }

    // we need to set the new file list to the new size
    setuploadList(fileList.slice(-(MAX_FILE_UPLOAD - 1)))

    if (file.status) {
      if (file.status === 'done') {
        console.log('file uploaded', file)
        dispatch({
          type: 'files/UPLOAD_FILE',
          payload: {
            status: file.status,
            file: file.response.data.dbFile,
            count: file.response.data.count,
            totalSize: file.response.data.totalSize,
          },
        })
      } else if (file.status === 'error') {
        let err = 'Error during file upload'
        console.log('file', file)
        const message = file.response ? file.response.message : err

        // Handle file upload error
        if (!_.isNull(message) || !_.isUndefined(message)) {
          err = message
        }

        // Error notification for the user
        notification.error({
          message: 'Error',
          description: `${err}`,
        })
      }
    }
  }

  return (
    <Modal
      visible={open}
      onCancel={() => {
        setuploadList([])
        setOpen(false)
      }}
      onOk={() => {
        setuploadList([])
        setOpen(false)
      }}
      closable={false}
      bodyStyle={{ height: '500px' }}
      // okButtonProps={{ disabled: okButtonDisable }}
    >
      <div>
        <Upload.Dragger
          className="mb-4"
          accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
          method="post"
          multiple
          onChange={d => {
            uploadImages(d)
            // setOkButtonDisable(false)
          }}
          fileList={uploadList}
          action={process.env.REACT_APP_BACKEND_UPLOAD}
          headers={{
            Authorization: `Bearer ${store.get('authToken')}`,
          }}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">Click or drag file to this area to upload</p>
          <p className="ant-upload-hint">
            Support for a single or bulk upload. Strictly prohibit from uploading company data or
            other brand files
          </p>
        </Upload.Dragger>
      </div>

      {/*  </Upload> */}
    </Modal>
  )
}

export default connect(mapStateToProps)(UploadModal)
